import { render } from "./footer1.vue?vue&type=template&id=45408230"
import script from "./footer1.vue?vue&type=script&lang=js"
export * from "./footer1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__